// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title-divider-left[data-v-0c17a0d4] {\r\n  border: 1px solid #b5c3bc;\r\n  opacity: 1;\r\n  margin-left: -7px;\n}\n.title-divider-right[data-v-0c17a0d4] {\r\n  border: 1px solid #b5c3bc;\r\n  opacity: 1;\r\n  margin-left: 7px;\n}\n.title-content[data-v-0c17a0d4] {\r\n  background: #3f5b60 0% 0% no-repeat padding-box;\r\n  border-radius: 21px;\r\n  opacity: 1;\r\n  text-align: center;\r\n  font: Bold 17px/23px Lato;\r\n  letter-spacing: 0;\r\n  color: #ffffff;\n}\r\n", ""]);
// Exports
module.exports = exports;
